import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  message,
  Modal,
  Form,
  Row,
  Steps,
  notification,
} from "antd";
import { AuditOutlined, RightOutlined } from "@ant-design/icons";
import moment from "moment";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

import { postCreateAdviseeBaseProfile } from "apis/advisee";
import { useFetchConstant } from "apis/constant";

import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import Tips from "components/Tips/Tips";

import {
  buildPPIReportingUri,
  buildAWPersonalUri,
  buildAWFinancialUri,
  buildAWSummaryUri,
  buildAdviseesUri,
  buildLeadDashboardUri,
} from "utils/routes";

import AWPersonalInfo from "./AWPersonalInfo/AWPersonalInfo";
import AWFinancialInfo from "./AWFinancialInfo/AWFinancialInfo";
import AWSummary from "./AWSummary/AWSummary";
import {
  ContentContainer,
  NavButtonsContainer,
  RootFormContainer,
  StepTitle,
  WizardNavHeader,
} from "./AdviseeWizard.styles";
import { withAppContext } from "contexts/AppContext/AppContext";
import { getLeadDetails } from "apis/lead";
import Locale from "react-intl-universal";

const { useForm } = Form;
const { Step } = Steps;
const { success, error } = Modal;

const tips = {
  dependentYears: (
    <p>
      For the <b>years of taking care of dependent</b>, you have to choose the{" "}
      <b>longest period of your supports</b>.
      <br />
      <br />
      For example,
      <br />
      <br />
      Joe has <b>2 dependents</b>, one is his kid and another one is his spouse.
      He plans to support his kid for the next 20 years while for his spouse
      will be the next 40 years.
      <br />
      <br />
      Since the support on his spouse is longer than his kid, his years of
      responsibility will be <b>40 years</b>.
    </p>
  ),
  totalIncome: (
    <p>
      <b>{Locale.get("adviseeWizard.totalIncome")}</b>
      <br />
      {Locale.get("adviseeWizard.totalIncomeContent")}
    </p>
  ),
  totalExpenses: (
    <p>
      <b>Total Expenses (every month)</b>
      <br />
      This includes all types of monthly epenses <b>EXCEPT</b> for loans
      repayments like mortgages, cars loan, credit card repayment, personal loan
      OR monthly premiums if insurance policies are added at the bottom of the
      page. Include expenses that are handled by your spouse (which not included
      in your own expenses list) if any.
    </p>
  ),
};

const AdviseeWizard = (props) => {
  const history = useHistory();
  const currentLocation = useLocation().pathname;
  const queryStringSeach = useLocation().search;
  const { leadId } = queryString.parse(useLocation().search);
  const [form] = useForm();
  const [currentFocusField, setCurrentFocusField] = useState("");
  const [formValues, setFormValues] = useState({});
  const [loans, setLoans] = useState([]);
  const [summaryValues, setSummaryValues] = useState({});
  const [policies, setPolicies] = useState([]);

  const [tipsTools, setTipTools] = useState({
    totalIncome: (
      <p>
        <b>{Locale.get("adviseeWizard.totalIncome")}</b>
        <br />
        {Locale.get("adviseeWizard.totalIncomeContent")}
      </p>
    ),
    totalExpenses: (
      <p>
        <b>{Locale.get("adviseeWizard.totalExpense")}</b>
        <br />
        {Locale.get("adviseeWizard.totalExpenseContent")}
      </p>
    ),
    dependentYears: (
      <p>
        <b>{Locale.get("adviseeWizard.dependentYears")}</b>
        <br />
        {Locale.get("adviseeWizard.dependentYearsContent")}
      </p>
    ),
  });

  const { data: adviseeCategoriesConst } = useFetchConstant(
    "adviseeCategories"
  );

  console.log(props.getLoggedInUser().country, 105);
  const country = props.getLoggedInUser().country;
  const defaultValues = {
    immediateDeathAmt: 58000.0,
    yearsOfTPDCoverage: { min: 10, max: 20 },
    yearsOfCICoverage: { min: 3, max: 5 },
    contact: {
      countryCode: "+60",
    },
    joinDate: moment(),
    medicalHealthInsuranceNeeds: country === "Indonesia" ? 2000000 : 200000,
  };
  console.log(defaultValues.medicalHealthInsuranceNeeds, 117);

  useEffect(() => {
    if (leadId) {
      retrieveLeadDetails(leadId);
    }
  }, [queryStringSeach.leadId]);

  const capitalizeFirstLetter = (string) => {
    if (!string) {
      return "";
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const retrieveLeadDetails = async (leadId) => {
    message.loading("Retrieving lead info");
    getLeadDetails(leadId)
      .then((res) => {
        console.log(res, 112);
        message.destroy();
        notification.info({
          message: Locale.get("Advisees.adviseeWizard.info"),
          description: `${Locale.get(
            "Advisees.adviseeWizard.leadDesc_a"
          )} \n ${Locale.get("Advisees.adviseeWizard.leadDesc_a")}`,
        });

        setTimeout(() => {
          form.setFields([
            {
              name: "leadId",
              value: leadId,
            },
            {
              name: "contact",
              value: {
                countryCode: res.contact.countryCode,
                contactNumber: res.contact.contactNumber,
              },
            },
            {
              name: "name",
              value: {
                firstName: res.name.firstName,
                lastName: res.name.lastName,
              },
            },
            {
              name: "dob",
              value: moment(res.dob),
            },
            {
              name: "email",
              value: res.email,
            },
            {
              name: "occupation",
              value: res.occupation,
            },
            {
              name: "gender",
              value: res.gender,
            },
            {
              name: "nric",
              value: res.nric,
            },
            {
              name: "marital_status",
              value: res.marital_status,
            },
            {
              name: "marital_status_other",
              value: res.marital_status_other,
            },
            {
              name: "loan",
              value: [
                {
                  amount: 5000,
                  isInsuranceCovered: true,
                  loanBalance: 200,
                  type: "investmentMortgageLoan",
                },
              ],
            },
            {
              name: "totalExpenses",
              value: res.personal_expenses,
            },
          ]);

          // ------------------Configure Loans Start ------------------
          form.setFields([
            {
              name: "hasPayment",
              value: {
                value: res.property.length > 0,
              },
            },
          ]);

          var loanBuffer = [];
          if (res.property.length > 0) {
            res.property.forEach((propertyLoan) => {
              loanBuffer.push({
                amount: propertyLoan.mortgage_monthly_installment,
                isInsuranceCovered: propertyLoan.is_insured === "Yes",
                loanBalance: propertyLoan.mortgage_loan_amount,
                type: propertyLoan.purchase_purpose,
              });
            });
          }
          setLoans([...loanBuffer]);
          // ------------------Configure Loans End ------------------

          // ------------------Configure Family & Dependant Start ------------------
          // hasDependent
          if (
            res.have_children === "Yes" ||
            res.family_member_to_take_care === "Yes"
          ) {
            var highest_dependant_year = 0;
            var dob_deduction = 0;
            var firstName = "";
            if (
              parseInt(
                res.legafamily_member_to_take_care_extra
                  ? res.legafamily_member_to_take_care_extra
                  : 0
              ) > parseInt(res.children_age_extra ? res.children_age_extra : 0)
            ) {
              highest_dependant_year = String(
                res.legafamily_member_to_take_care_extra
              );
              firstName = "parent";
            } else {
              highest_dependant_year = String(res.children_age_extra);
              dob_deduction = res.children_age;
              firstName = "child";
            }

            form.setFields([
              {
                name: "familyMember",
                value: {
                  dob: moment().subtract(dob_deduction, "year").startOf("year"),
                  name: {
                    firstName: capitalizeFirstLetter(firstName),
                    lastName: res.name.lastName,
                  },
                  relationship: firstName,
                  // yearOfIndependence: "2040",
                  yearsOfResponsible: highest_dependant_year,
                },
              },
              {
                name: "hasDependent",
                value: {
                  value: true,
                },
              },
            ]);
          }

          // ------------------Configure Family & Dependant End ------------------
        }, 250);
      })
      .then((err) => {
        console.log(err, 117);
      });
  };

  const constructSummaryValues = (values) => {
    const {
      name,
      dob,
      familyMember,
      hasDependent,
      immediateDeathAmt,
      recoverRecuperatingFund,
      loans,
      policies,
      totalIncome,
      totalExpenses,
    } = values;
    const personalInfo = {
      name: name ? `${name.firstName || ""} ${name.lastName || ""}` : "",
      dob,
      age: (dob && Math.abs(dob.diff(new Date(), "years"))) || 0,
    };

    const dependentYears =
      hasDependent && hasDependent.value
        ? Number(familyMember.yearsOfResponsible)
        : 0;

    const financialInfo = {
      totalIncome: Number(totalIncome) || 0,
      totalExpenses: Number(totalExpenses) || 0,
      totalLoan:
        (loans &&
          loans.reduce((total, loan) => Number(loan.amount) + total, 0)) ||
        0,
      totalLoanBalance:
        (loans &&
          loans.reduce((total, loan) => Number(loan.loanBalance) + total, 0)) ||
        0,
      totalCoverages:
        (policies &&
          policies.reduce(
            (total, policy) => Number(policy.totalCoverage) + total,
            0
          )) ||
        0,
      totalMonthlyPremiums:
        (policies &&
          policies.reduce(
            (total, policy) => Number(policy.monthlyPremium) + total,
            0
          )) ||
        0,
      minYearsOfResponsibility: dependentYears || 3,
      immediateDeathAmt: Number(immediateDeathAmt) || 0,
      recoverRecuperatingFund: Number(recoverRecuperatingFund) || 0,
    };

    return {
      personalInfo,
      financialInfo,
      dependentYears,
    };
  };

  const handleOnPersonalInfoNextButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      setFormValues({ ...formValues, ...values });
      setCurrentFocusField("");
      history.push(
        `${buildAWFinancialUri()}${queryStringSeach && queryStringSeach}`
      );
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  const handleOnFinancialInfoNextButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      const newFormValues = { ...formValues, ...values, loans, policies };
      setFormValues(newFormValues);
      setSummaryValues(constructSummaryValues(newFormValues));
      setCurrentFocusField("");
      history.push(
        `${buildAWSummaryUri()}${queryStringSeach && queryStringSeach}`
      );
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  const formatFormValues = (formValues) => {
    const {
      name,
      dob,
      contact,
      email,
      isClient,
      joinDate,
      totalIncome,
      totalExpenses,
      loans,
      policies,
      yearsOfTPDCoverage,
      yearsOfCICoverage,
      immediateDeathAmt,
      recoverRecuperatingFund,
      familyMember,
      nric,
      gender,
      occupation,
      leadId,
      marital_status,
      marital_status_other,
      medicalHealthInsuranceNeeds,
      isSmoker,
      remarks,
    } = formValues;
    const newValues = {
      name,
      dob: dob.format("YYYY-MM-DD"),
      contact,
      email,
      occupation,
      nric,
      gender,
      isSmoker,
      remarks,
      marital_status,
      marital_status_other,
      medicalHealthInsuranceNeeds,
      category:
        isClient && isClient.value
          ? adviseeCategoriesConst.CLIENT.code
          : adviseeCategoriesConst.PROSPECT.code,
      joinDate:
        isClient && isClient.value ? joinDate.format("YYYY-MM-DD") : undefined,
      cashFlow: {
        totalIncome,
        totalExpenses,
      },
      yearsOfTPDCoverage,
      yearsOfCICoverage,
      immediateDeathAmt,
      recoverRecuperatingFund,
      familyMember: familyMember
        ? {
            ...familyMember,
            dob: familyMember.dob && familyMember.dob.format("YYYY-MM-DD"),
            yearOfIndependence:
              familyMember.yearsOfResponsible &&
              moment()
                .add(familyMember.yearsOfResponsible, "year")
                .format("YYYY"),
          }
        : undefined,
      loanPayments: loans.map((loan) => ({
        ...loan,
        amount: {
          self: Number(loan.amount),
          spouse: 0,
        },
        loanBalance: Number(loan.loanBalance),
      })),
      // policies: policies.map((policy) => ({
      //   ...policy,
      //   commencementDate: policy.commencementDate
      //     ? policy.commencementDate.format("YYYY-MM-DD")
      //     : undefined,
      //   maturityDate: policy.maturityDate
      //     ? policy.maturityDate.format("YYYY-MM-DD")
      //     : undefined,
      // })),
      policies,
      leadId,
    };
    return newValues;
  };

  const handleOnFinishButtonClick = () => {
    const formattedPayloadForBaseProfile = formatFormValues(formValues);
    postCreateAdviseeBaseProfile(formattedPayloadForBaseProfile)
      .then((res) => {
        success({
          title: Locale.get("Advisees.adviseeWizard.createAdviseeSuccess"),
          okText: Locale.get("Advisees.adviseeWizard.goReporting"),
          onOk() {
            history.push(buildPPIReportingUri(res._id));
          },
        });
      })
      .catch((ex) => {
        error({
          title: Locale.get("Advisees.adviseeWizard.unableCreateAdvisee"),
        });
      });
  };

  const handleOnPersonalInfoPrevButtonClick = () => {
    setCurrentFocusField("");
    if (leadId) {
      history.push(buildLeadDashboardUri());
    } else {
      history.push(buildAdviseesUri());
    }
  };

  const handleOnFinancialInfoPrevButtonClick = () => {
    setCurrentFocusField("");
    history.push(buildAWPersonalUri());
  };

  const handleOnSummaryPrevButtonClick = () => {
    setCurrentFocusField("");
    history.push(buildAWFinancialUri());
  };

  const stepsObj = {
    [buildAWPersonalUri()]: {
      title: Locale.get("Advisees.adviseeWizard.personalInfo"),
      prevNav: {
        label: Locale.get("Advisees.adviseeWizard.backToViewAll"),
        onClick: handleOnPersonalInfoPrevButtonClick,
      },
      nextNav: {
        label: Locale.get("Advisees.adviseeWizard.next"),
        icon: <RightOutlined />,
        onClick: handleOnPersonalInfoNextButtonClick,
      },
    },
    [buildAWFinancialUri()]: {
      title: Locale.get("Advisees.adviseeWizard.finInfo"),
      prevNav: {
        label: Locale.get("Advisees.adviseeWizard.backToPrev"),
        onClick: handleOnFinancialInfoPrevButtonClick,
      },
      nextNav: {
        label: Locale.get("Advisees.adviseeWizard.next"),
        icon: <RightOutlined />,
        onClick: handleOnFinancialInfoNextButtonClick,
      },
    },
    [buildAWSummaryUri()]: {
      title: Locale.get("Advisees.adviseeWizard.summary"),
      prevNav: {
        label: Locale.get("Advisees.adviseeWizard.backToPrev"),
        onClick: handleOnSummaryPrevButtonClick,
      },
      nextNav: {
        label: Locale.get("Advisees.adviseeWizard.saveGenerateReport"),
        icon: <AuditOutlined />,
        onClick: handleOnFinishButtonClick,
      },
    },
  };

  const currentStep = stepsObj[currentLocation];

  const shouldShowTips = currentLocation !== buildAWSummaryUri();

  const isAllowToAccessFinancialPage = !!formValues.name;
  const isAllowToAccessSummaryPage =
    summaryValues && Object.keys(summaryValues).length > 0;

  return (
    <RootFormContainer form={form} initialValues={defaultValues}>
      <WizardNavHeader>
        <NavButtonsContainer justify="space-between" align="middle">
          <ClickableTextButton
            text={currentStep.prevNav.label}
            onClick={currentStep.prevNav.onClick}
            type="back"
            showIcon={true}
          />
          <Button
            type="primary"
            icon={currentStep.nextNav.icon}
            onClick={currentStep.nextNav.onClick}
          >
            {currentStep.nextNav.label}
          </Button>
        </NavButtonsContainer>
        <Row>
          <Steps
            current={Object.keys(stepsObj).findIndex(
              (key) => key === currentLocation
            )}
          >
            {Object.values(stepsObj).map((step) => (
              <Step
                title={
                  <StepTitle
                    isActive={currentStep.title === step.title}
                    key={step.title}
                  >
                    {step.title}
                  </StepTitle>
                }
                key={step.title}
              />
            ))}
          </Steps>
        </Row>
      </WizardNavHeader>
      <ContentContainer shouldShowTips={shouldShowTips}>
        <Col span={shouldShowTips ? 14 : 24}>
          <Switch>
            <Route path={buildAWPersonalUri()}>
              <AWPersonalInfo onFieldFocus={setCurrentFocusField} />
            </Route>
            <Route path={buildAWFinancialUri()}>
              <AWFinancialInfo
                allowToAccess={isAllowToAccessFinancialPage}
                onFieldFocus={setCurrentFocusField}
                loans={loans}
                setLoans={setLoans}
                policies={policies}
                setPolicies={setPolicies}
              />
            </Route>
            <Route path={buildAWSummaryUri()}>
              <AWSummary
                allowToAccess={isAllowToAccessSummaryPage}
                personalInfo={summaryValues.personalInfo}
                financialInfo={summaryValues.financialInfo}
                dependentYears={summaryValues.dependentYears}
              />
            </Route>
          </Switch>
        </Col>
        <Col span={shouldShowTips ? 10 : 0}>
          <Row>
            {/* {console.log(619,tipsTools[currentFocusField])} */}

            {tipsTools[currentFocusField] && (
              <Tips
                title={Locale.get("adviseeWizard.tips")}
                description={tipsTools[currentFocusField].props.children}
                isSticky={true}
                showIcon={true}
              />
            )}
          </Row>
        </Col>
      </ContentContainer>
    </RootFormContainer>
  );
};

export default withAppContext(AdviseeWizard);
